import { mapState } from 'vuex';
import tenantPickerMixin from './pickerMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'CoreTenantTermsAndConditions',
  components: {
    MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    termsAndConditions: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data: function () {
    return {
      markdownEdit: false
    };
  },
  computed: {
    ...mapState('app', ['image', 'color', 'inpOutlined', 'inpFilled', 'UiTheme']),
    inputTemplateStyle() {
      return ['font-family: monospace;', 'font-weight: 500;', 'font-size: 14px;', 'line-height: 1.5em;', 'white-space: pre-wrap;', 'tab-size: 2;', '-webkit-tab-size: 2;', '-moz-tab-size: 2;', '-o-tab-size: 2;;'].join(' ');
    }
  }
};